import React, { useState, useMemo } from "react";
import "../DashboardUnique.css";
import { exportVillagesToExcel, exportVillagesToPDF, toIndianCurrency, toIndianCurrencyVillageCard } from "../../../MethodMaster/JSXComponentMothod";

const ShimmerCard = () => (
  <div className="govdash-villageCard-final">
    <div className="village-shimmer" style={{ height: "1rem", marginBottom: "0.6rem" }}></div>
    <div className="village-shimmer" style={{ height: "1.7rem" }}></div>
  </div>
);

const NoDataCard = () => (
  <div className="govdash-villageCard-final govdash-noVillageCard">
    <div className="govdash-noDataIcon">
      <i className="fas fa-village fa-2x"></i>
    </div>
    <div className="govdash-noDataTitle">No Villages Found</div>
    <div className="govdash-noDataDesc">
      {document.querySelector(".govdash-searchInput")?.value ? "Try searching with different keywords" : "No villages available under this Yojana"}
    </div>
  </div>
);

export default function VillageGrid({ selYojna = null, villages = [], onSelect, isLoading = false }) {
  const [search, setSearch] = useState("");
  const themes = ["glass-0", "glass-1", "glass-2", "glass-3", "glass-4"];

  const filteredVillages = useMemo(() => {
    if (!search.trim()) return villages.filter((v) => v?.VillageNameEnglish?.trim());
    return villages.filter((v) => v?.VillageNameEnglish?.toLowerCase().includes(search.toLowerCase()));
  }, [villages, search]);
  const handleExcel = () => exportVillagesToExcel(selYojna, filteredVillages, "Villages_Under_Yojna");
  // const handlePDF = () => exportVillagesToPDF(selYojna, filteredVillages, "Villages_Under_Yojna")
  return (
    <>
      <div className="d-flex flex-column flex-md-row justify-content-between gap-3 gap-md-0">
        <h3 className={"govdash-sectionTitle"}>
          Villages under this Yojna&nbsp;&nbsp;&nbsp;{" "}
          <div className="govdash-totalCountBadge">
            {/* <span className="govdash-totalLabel">Total Yojanas :</span> */}
            <span className="govdash-totalNumber">{villages.length}</span>
          </div>
        </h3>
        {/* Search Bar */}
        <div className="d-flex gap-2">
          <div className="d-flex gap-3 align-items-center flex-wrap">
            <div className="govdash-searchWrapper">
              <i className="fas fa-search "></i>
              <input type="text" placeholder="Search Yojna Name..." value={search} onChange={(e) => setSearch(e.target.value)} className="govdash-searchInput" />
              {search && (
                <button onClick={() => setSearch("")} className="govdash-clearSearch">
                  <i className="fas fa-times"></i>
                </button>
              )}
            </div>
          </div>
          <div>
            <button onClick={handleExcel} className="govdash-excelBtn mt-4">
              <i className="fas fa-file-excel"></i> Export Excel
            </button>
          </div>
          {/* <div>
          <button onClick={handlePDF} className="govdash-pdfBtn mt-4">
            <i className="fas fa-file-pdf"></i> Download PDF
          </button>
          </div> */}
        </div>
      </div>

      <div className="govdash-villageGrid-final">
        {isLoading ? (
          Array(24)
            .fill()
            .map((_, i) => <ShimmerCard key={i} />)
        ) : filteredVillages.length > 0 ? (
          filteredVillages.map((v, idx) => {
            const theme = themes[idx % 5];
            const hasAmount = v?.TotalAmount > 0;

            return (
              <div key={v.id} className={`govdash-villageCard-final yojna-${theme}`} onClick={() => onSelect(v)}>
                <div className="village-header-final">
                  <div className="village-name-final">{v.VillageNameEnglish}</div>
                  {v?.VillageVoterCount > 0 && <div className="voter-badge">{v.VillageVoterCount.toLocaleString()} Voters</div>}
                </div>

                <div className="beneficial-row-final">
                  <span className="label">Labharthi</span>
                  <span className="value">{v?.BeneficialCount?.toLocaleString() || "0"}</span>
                </div>

                {/* {hasAmount && <div className="amount-row-final">₹{v.TotalAmount.toLocaleString("en-IN")}</div>} */}
                {hasAmount && <div className="amount-row-final">{toIndianCurrencyVillageCard(parseFloat(v?.TotalAmount || 0))}</div>}
              </div>
            );
          })
        ) : (
          <NoDataCard />
        )}
      </div>
    </>
  );
}
